module.exports = __webpack_public_path__ + "img/서비스이동교통.18c67c0d.png";